<section class="sh-dialog__content -sh-no-spacing">
    <sh-records-map
        [records]="records$ | async"
        [positionFieldDefinition]="positionFieldDefinition"
        [autoFitBounds]="false"
        [centerCoordinate]="coordinate"
        (boundsChange)="onBoundsChange($event)"
    >
    </sh-records-map>
</section>
